import React from "react";
import * as R from "ramda";
import Map from "react-map-gl";

import ErrorBoundary from "components/ErrorBoundary";
import styles from "components/maps/StaticMap.scss";
import { useAnswerContext } from "contexts/answerContext";
import { useCurrentTenant } from "contexts/currentTenant";
import { useServerVariables } from "contexts/serverVariables";
import { useClearances } from "queries/zoning";
import { useMapStyle } from "services/MapStyleBuilder";
import { isBlank } from "utils/func";

const StaticMap = ({ height = 200 }) => {
  const { record } = useAnswerContext();
  const { id: tenantID, tile_version } = useCurrentTenant();
  const address = R.path(["answers", "address"], record);
  const useCodeSlug = R.path(["answers", "project_type", "use", "slug"], record);

  const {
    data: { clearances = [], radiusRules = {} } = {},
    isLoading: clearancesLoading,
    error: clearancesError,
  } = useClearances(useCodeSlug);

  const { mapboxToken } = useServerVariables();
  const mapStyle = useMapStyle({
    tenantID,
    tileVersion: tile_version,
    clearances,
    radiusRules,
    address,
    type: "default",
  });

  if (!address || clearancesLoading || clearancesError) {
    return null; // or render a loading/error state
  }

  if (isBlank(address)) return null;

  const { latitude, longitude } = address;

  return (
    <div className={styles.mapContiner}>
      <ErrorBoundary>
        <Map
          style={{ height }}
          mapStyle={mapStyle}
          latitude={latitude}
          longitude={longitude}
          zoom={16}
          mapboxAccessToken={mapboxToken}
        />
      </ErrorBoundary>
    </div>
  );
};

export default StaticMap;
